<div  class="bottom-sheet-container" [ngClass]="bottomSheetExpandedState()">
    <div class="bottom-sheet">
        <div class="bottom-sheet-header" #bottomSheetRef>
            <p class="title">
                @if (bottomSheetUiConfigState()) {
                    {{ bottomSheetUiConfigState().title }}
                }
            </p>
            <div class="tools">
                <button class="tool-button" (click)="toggleBottomSheetState()">
                    @if (bottomSheetExpandedState() === 'maximized') {
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    } @else {
                        <mat-icon>keyboard_arrow_up</mat-icon>
                    }
                </button>
                <button class="tool-button" (click)="onCloseBtnClick()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
        <!-- <div class="bottom-sheet-content" ></div> -->
    </div>
</div>